<template>
  <DropDownContainer
    v-model="listVisible"
  >
    <template v-slot:target>
      <MultiselectSearchButton
        @click="handleButtonClick"
      >
        <span>IP Lists: <strong>{{ value.length }} lists</strong></span>
      </MultiselectSearchButton>
    </template>
    <template v-slot:dropDown>
      <MultiselectMenu
        :loading="isLoading"
        :options="options"
        :value="value"
        @input="handleInput"
      >
        <template v-slot:noOptionsAvailableMessage>
          <p>No <strong>{{ ipListLabels.plural }}</strong> have been added yet</p>
          <p>
            Go to <strong>Conditional Lists</strong>
            under Security Management to add a new {{ ipListLabels.singular }}.
          </p>
        </template>
      </MultiselectMenu>
    </template>
  </DropDownContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import pluralize from 'pluralize';

import DropDownContainer from 'components/DropDownMenu/DropDownContainer.vue';
import MultiselectMenu from 'components/DropDownMenu/DropDownMultiSelectSearch/MultiSelectMenu.vue';
import MultiselectSearchButton from 'components/DropDownMenu/DropDownMultiSelectSearch/MultiSelectSearchButton.vue';

import { ItemTypeConsts, ItemTypeDisplayNames, StoreModuleMap } from 'client/util/Constants';

const ipListsCollection = StoreModuleMap[ItemTypeConsts.ipList];

export default {
  name: 'IpListSearch',

  components: {
    DropDownContainer,
    MultiselectMenu,
    MultiselectSearchButton,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      listVisible: false,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(ipListsCollection, ['getCollection']),
    ipListLabels() {
      const singular = ItemTypeDisplayNames[ItemTypeConsts.ipList];
      return {
        singular,
        plural: pluralize(singular),
      };
    },
    options() {
      return this.getCollection.map(ipList => ({ name: ipList.name, value: ipList.id }));
    },
  },

  mounted() {
    this.isLoading = true;
    this.fetchCollection().finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    ...mapActions(ipListsCollection, ['fetchCollection']),
    handleButtonClick() {
      this.listVisible = !this.listVisible;
    },
    handleInput(newValue) {
      this.$emit('input', newValue);
    },
  },
};

</script>
